<template>
  <div class="container">
    <div class="issue">
      <div class="issue-body">
        <div
          :class="[`issue-body-item`, i == 0 ? `issue-body-item-1` : ``]"
          v-for="(s, i) in issue"
          :key="i"
        >
          <div class="issue-body-label">Q：{{ s.q }}</div>
          <div class="issue-body-value">A：{{ s.a }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyIssue",
  data() {
    return {
      issue: [
        {
          q: "找人帮忙适合公司吗?",
          a: "不适合, 找人帮忙适用于个人有需求要人帮忙"
        },
        {
          q: "在平台上找兼职是否收费？",
          a: "以任何名义收取费用都需警惕，不要轻易参加此类兼职工作"
        },
        {
          q: "兼职报名之后商家会联系你吗？",
          a: "在报名工作职位后，商家会根据报名该职位的所有斗米会员的简历进行筛选，选定后会第一时间 联系确定工作或面试时间，也可以选择主动联系商家"
        },
        {
          q: "播聘的兼职招聘信息可靠吗？",
          a: "播聘上发布的兼职岗位都是经过审核后才上线的；对于播聘担保职位可以放心参与；对于收费职位，请详细关注收费内容， 如有额外收费情况，请及时向播聘客服举报"
        },
        {
          q: "用户在平台报名，手机号会泄露吗？",
          a: "在播聘平台注册信息（包括商家员），都会受到保护不会泄露"
        }
      ]
    };
  }
};
</script>

<style scoped="scoped">
@import url("./company-issue.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-issue/company-issue.vue